import { render, staticRenderFns } from "./TrainingDetailsTable.vue?vue&type=template&id=3aab8900&scoped=true&"
import script from "./TrainingDetailsTable.vue?vue&type=script&lang=js&"
export * from "./TrainingDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDetailsTable.vue?vue&type=style&index=0&id=3aab8900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aab8900",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VContainer,VDataTable})
